import * as React from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/nl';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, InputLabel, useTheme } from '@mui/material';

dayjs.extend(customParseFormat);

export default function DatePickerComponent({
  value,
  label,
  name,
  onChange,
  error,
  helperText,
  lang,
}) {
  React.useEffect(() => {
    dayjs.locale(lang.toLowerCase());
  }, [lang]);
  const theme = useTheme();
  const parsedValue = React.useMemo(() => {
    if (!value || typeof value !== 'string' || value.trim() === '') {
      return null; 
    }

    const dateObj = dayjs(value, "DD-MM-YYYY", true);
    return dateObj.isValid() ? dateObj : null; 
  }, [value]);

  return (
    <Box sx={{ mt: 1, width: '100%' }}>
      <InputLabel
        sx={{
          mb: 2,
          fontWeight: 'bold',
          fontSize: '15px',
          color: theme?.details?.formLabelColor,
          mt: 1,
        }}
        htmlFor={name}
      >
        {label}
      </InputLabel>

      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lang?.toLowerCase()}>
        <DatePicker
          name={name}
          value={parsedValue} // Use the fixed parsedValue
          onChange={(newValue) => {
            const date = newValue ? dayjs(newValue).format('DD-MM-YYYY') : '';
            onChange(name, date);
          }}
          format="DD-MM-YYYY"
          slotProps={{
            textField: { error, helperText },
          }}
          sx={{width:"100%",
          '& fieldset': {
            borderColor: error ? 'red' : '#EBEBEB',
          },
          '&:hover fieldset': {
            borderColor: error ? 'red' : '#EBEBEB',
          },
          '&.Mui-focused fieldset': {
            borderColor: error ? 'red' : '#0B5753',
          },
        }}
        />
      </LocalizationProvider>
    </Box>
  );
}
